/** In-memory cache — cleared on full page reload or when user id changes. */
const store = new Map();

export const buildTabCacheKey = (...parts) =>
  parts.filter((p) => p !== undefined && p !== null && p !== '').join(':');

export const getTabCache = (key) => store.get(key);

export const setTabCache = (key, value) => {
  store.set(key, value);
};

export const clearTabCacheForUser = (userId) => {
  if (!userId) return;
  const prefix = `${userId}:`;
  for (const key of store.keys()) {
    if (key.startsWith(prefix)) {
      store.delete(key);
    }
  }
};
